import { RecoveryAudit } from "@/features/recovery/recovery-audit";

export default function RecoveryAuditPage() {
  return <RecoveryAudit />;
}
